import z from 'zod';

import i18n from '@dms/i18n';

import {DocumentExtractionImportFileSchema} from './DocumentExtractionImportFile';

const MAX_DOCUMENTS = 30;

export const DocumentExtractionImportFormDefinitionSchema = z.object({
  taskType: z.enum(['EXTRACT_DELIVERY_NOTE']),
  filesToImport: z
    .array(DocumentExtractionImportFileSchema)
    .max(MAX_DOCUMENTS, {
      message: i18n.t('entity.documentExtraction.labels.maxDocumentsToUpload', {
        count: MAX_DOCUMENTS,
      }),
    })
    .nullish(),
});

export type DocumentExtractionImportFormDefinition = z.infer<
  typeof DocumentExtractionImportFormDefinitionSchema
>;
